import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserService } from '../../../common/user/user.service';
import { BasePlusComponent } from '../../../_shared/components/base/base-plus.component';

@Injectable({
  providedIn: 'root',
})
export class ParamsService extends BasePlusComponent {
  private _types = new BehaviorSubject<string[] | null>(null);
  public userService = inject(UserService);
  private isBrowser: boolean;

  setTypes(types: string[]) {
    if (this.isPlatformBrowser()) {
      localStorage.setItem('types', JSON.stringify(types));
    }
    this._types.next(types);
  }

  getTypes() {
    return this._types.asObservable();
  }

  loadFromStorage(): string[] | null {
    if (!this.isPlatformBrowser()) return null;
    const savedTypes = localStorage.getItem('types');
    if (savedTypes?.length > 0) {
      return JSON.parse(savedTypes);
    }
    return null;
  }

  saveSelectedTypes(types: string[]) {
    if (this.isPlatformBrowser()) {
      localStorage.setItem('selectedTypes', JSON.stringify(types));
    }
  }

  loadSelectedTypes(): string[] {
    if (!this.isPlatformBrowser()) return [];
    const storedTypes = localStorage.getItem('selectedTypes');
    return storedTypes ? JSON.parse(storedTypes) : [];
  }

  removeSelectedTypes() {
    if (this.isPlatformBrowser()) {
      localStorage.removeItem('selectedTypes');
    }
  }

  removeTypes() {
    if (this.isBrowser) {
      localStorage.removeItem('types');
    }
  }

  setKindsFromUrlTypes(types: string[]) {
    this.removeSelectedTypes();
    this.setTypes(types);
  }
}
